(function(win) {
  'use strict';

  let listeners = [],
    doc = win.document,
    MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
    observer;

  function check() {
    for (let i = 0, len = listeners.length, listener, elements; i < len; i++) {
      listener = listeners[i];
      elements = doc.querySelectorAll(listener.selector);
      for (let j = 0, jLen = elements.length, element; j < jLen; j++) {
        element = elements[j];
        if (!element.ready) {
          element.ready = true;
          listener.fn.call(element, element);
        }
      }
    }
  }

  function ready(selector, fn) {
    listeners.push({
      selector: selector,
      fn: fn
    });
    if (!observer) {
      observer = new MutationObserver(check);
      observer.observe(doc.documentElement, {
        childList: true,
        subtree: true
      });
    }
    check();
  }

  win.ready = ready;
})(window);
